import React, { Component } from 'react';
import moment from 'moment-timezone';
import * as $ from 'jquery';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter, Redirect } from 'react-router-dom';
import axios from 'axios';
import brandLogo from '../../images/Portada_ios.png';
import MarketplaceContainer from './MarketplaceContainer.js'
import { Link } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;


class ProfileUser extends Component {

    getInitState = () => {
        return {
            profile: [],
            profileUser: [],
            solicitud: true,
            user_id: ""
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        this.getProfileById({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            user_id: this.props.match.params.userid,
        });

        this.getProfile({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            user_id: this.props.match.params.userid,
        });
    }

    getProfileById = (params) => {
        this.props.post(
            "/getProfileUserById",
            params,
            (response) => this.didGetProfileById(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getProfile = (params) => {
        this.props.post(
            "/getProfileUser",
            params,
            (response) => this.didGetProfile(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getConnections = (params) => {
        this.props.post(
            "/addConnections",
            params,
            (response) => this.didgetConnections(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );

    }

    getdelateConnections = (params) => {
        this.props.post(
            "/delateConnections",
            params,
            (response) => this.diddelateConnections(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getaceptConnections = (params) => {
        this.props.post(
            "/aceptConnections",
            params,
            (response) => this.didaceptConnections(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetProfileById = (response) => {
        this.setState({ profile: response, user_id: this.props.match.params.userid })
    }

    didGetProfile = (response) => {
        this.setState({ profileUser: response })
    }

    didgetConnections = (response) => {
        alert('Solicitud de Conexion Enviada')
        this.reload();
    }

    diddelateConnections(response) {
        alert("Conexion eliminada");
        this.reload();
    }

    didEmialConnections(response) {
    }

    didaceptConnections(response) {
        alert("Conexion establecida");
        this.reload();
    }

    handleErrorResponse = (error) => {
    }

    handledelateConnections = () => {
        this.getdelateConnections({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            contact_id: this.props.match.params.userid
        });
    }
    

    handleacceptConnections = () => {
        this.getaceptConnections({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            contact_id: this.props.match.params.userid
        });
    }

    handleConnections = () => {
        this.getConnections({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            contact_id: this.props.match.params.userid,
        });
    }

    renderMarketplaceContainer = () => {
        return (
            <MarketplaceContainer
                getTokenId={this.props.getTokenId}
                getTokenSession={this.props.getTokenSession}
                handleErrorResponse={this.props.handleErrorResponse}
                post={this.props.post}
                user={this.props.user} />
        );
    }

    render() {
        const { t } = this.props;
        const profile = this.state.profile;
        const portada = this.state.profile.portada ? profile.portada : brandLogo;
        const user_id = this.state.user_id;
        const connection = profile.connection
        if (!this.props.user.memberId) {
            return <Redirect to="/" />;
        }
        return (
            <div className="content-profile">
                <div className="container-profile">
                    <div className="container-room-header card-panel panel panel-default card">
                        <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + portada + "')" }}>
                        </div>
                        <div className="card-panel-body">
                            <div className="profile">
                                <div className="badge-wrapper">
                                    <img
                                        className="cover-img__image relative w-full h-full object-cover img-responsive"
                                        alt={t('dashboard.profile.img_user')}
                                        src={profile.picture}
                                        loading="lazy" data-embed-id="cover-image" />
                                </div>
                            </div>
                            <div className="profile-description">
                                <div className="user-data">
                                    <div>
                                        <h4 className="ioscentro">{profile.name + " " + profile.lastname} {profile.user_id ? "#" + profile.user_id : null}<br></br></h4>
                                        <h4 className="ioscentro">{profile.position ? profile.position : ""} </h4>
                                    </div>
                                    {connection ? (
                                        <div>
                                            {connection.estatus === "Aceptada" ? (
                                                <div>
                                                    <h4 className="ioscentro">Correo de Contacto: {profile.contact_email ? profile.contact_email : ""} </h4>
                                                    <h4 className="ioscentro">Telefono de Contacto: {profile.phone ? profile.phone : ""} </h4>
                                                    <div>
                                                        {profile.business_name ? (
                                                            <button type="button" className="btn btn-default">
                                                                {profile.business_name}
                                                            </button>
                                                        ) : null}
                                                    </div>
                                                    <div>
                                                        {profile.center ? (
                                                            <button type="button" className="btn btn-default">
                                                                {profile.center.center_name}
                                                            </button>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            ) : (
                                                connection.id_solicitante === user_id ? (
                                                    <h4 className="ioscentro" style={{ background: "#33CCCC", padding: "5px", border: "2px solid black" }}>
                                                        Solicitud de Pendiente
                                                    </h4>
                                                ) : (
                                                    <h4 className="ioscentro" style={{ background: "#33CCCC", padding: "5px", border: "2px solid black" }}>
                                                        Solicitud de Conexión Enviada
                                                    </h4>
                                                )
                                            )}
                                        </div>
                                    ) : profile.business_name && profile.perfil_publico === "1" ? (
                                        <button type="button" className="btn btn-default">
                                            {profile.business_name}
                                        </button>
                                    ) : null}
                                </div>
                                <div className="user-work-data-infomacion">
                                    {profile.perfil_publico === "1" ? (
                                        <div className="user-work-data">
                                            <div className="profile-company">
                                                <img className="cover-img__image relative w-full h-full object-cover img-responsive"
                                                    src={profile.company_picture}
                                                    loading="lazy" data-embed-id="cover-image" alt="" />
                                            </div>
                                            <div className="profile-company-name">
                                                <h4 className="company-name">{profile.company ? profile.company : "company"}</h4>
                                            </div>
                                        </div>
                                    ) : null}
                                    {profile.perfil_facebook ? (
                                        <div className="user-work-data">
                                            <div className="profile-company">
                                                <i className="fa fa-facebook-official cover-img__image relative w-full h-full object-cover img-responsive" aria-hidden="true"></i>
                                            </div>
                                            <div className="profile-company-name">
                                                <Link className="img-responsive redes" to={profile.perfil_facebook}>
                                                    <h4 className="company-redes">Facebook</h4>
                                                </Link>
                                            </div>

                                        </div>
                                    ) : null}
                                    {profile.perfil_Instragram ? (
                                        <div className="user-work-data">
                                            <div className="profile-company">
                                                <i className="fa fa-instagram cover-img__image relative w-full h-full object-cover img-responsive" aria-hidden="true"></i>
                                            </div>
                                            <div className="profile-company-name">
                                                <Link className="img-responsive redes" to={profile.perfil_Instragram}>
                                                    <h4 className="company-redes">Instagram</h4>
                                                </Link>
                                            </div>

                                        </div>
                                    ) : null}
                                    {profile.perfil_Linkedin ? (
                                        <div className="user-work-data">
                                            <div className="profile-company info-icons">
                                                <i className="fa fa-linkedin cover-img__image relative w-full h-full object-cover img-responsive fa-6" aria-hidden="true"></i>
                                            </div>
                                            <div className="profile-company-name">
                                                <Link className="img-responsive redes" to={profile.perfil_Linkedin}>
                                                    <h4 className="company-redes">Linkedin</h4>
                                                </Link>
                                            </div>

                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="user-description profile-description ">
                                {connection ? (
                                    <div>
                                        {connection.estatus === "Pendiente" ? (
                                            <div>
                                                {connection.id_solicitante === user_id ? (
                                                    <button type="button" style={{ margin: "5px" }} className="btn btn-primary" onClick={this.handleacceptConnections} data-toggle="modal" data-target=".bs-example-modal-sm">
                                                        Aceptar Solicitud de Conexión
                                                    </button>
                                                )
                                                    : null}
                                                <button type="button" style={{ margin: "5px" }} className="btn btn-primary" onClick={this.handledelateConnections} data-toggle="modal" data-target=".bs-example-modal-sm">
                                                    Eliminar Solicitud de Conexión
                                                </button>
                                            </div>
                                        ) : (
                                            <button type="button" style={{ margin: "5px" }} className="btn btn-primary" onClick={this.handledelateConnections} data-toggle="modal" data-target=".bs-example-modal-sm">
                                                Cancelar Conexión
                                            </button>
                                        )}
                                    </div>
                                ) : (
                                    profile.perfil_publico === "1" && this.state.profileUser.perfil_publico === "1" ? (
                                        <button type="button" style={{ margin: "5px" }} className="btn btn-primary" data-toggle="modal" data-target=".bs-example-modal-sm" onClick={this.handleConnections}>
                                            HAZ Conexión
                                        </button>
                                    ) : (this.state.profileUser.perfil_publico === "0" ?
                                        (<h4 className="page-header">
                                            {t('dashboard.conecctions.make_puclic_Connection')}
                                        </h4>) : null)
                                )}

                            </div>
                            <div className="user-description profile-description" style={{ textAlign: "left" }}>
                                {profile.description}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-room-description">
                    <div className="col-md-7 profile_markrplace">
                        {/* {this.renderMarketplaceContainer()} */}
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(ProfileUser);



// WEBPACK FOOTER //
// ./src/dashboard/profileUser/ProfileUser.js